// extracted by mini-css-extract-plugin
module.exports = {"secondFold":"secondFold_secondFold__FfVHR","mainDiv":"secondFold_mainDiv__SnZ5Y","heading":"secondFold_heading__uEUQ_"};